// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "sms_account_suppression".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "sms_account_suppression" table (1:1 with a DB row, on the wire). */
export const smsAccountSuppressionAtomSchema = z.object({
    accountReference: z.string(),
    contact: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=smsAccountSuppression.js.map